import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import u from "./CanceledError.js";
var c = /*#__PURE__*/function () {
  function c(e) {
    _classCallCheck(this, c);
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    var t;
    this.promise = new Promise(function (r) {
      t = r;
    });
    var s = this;
    this.promise.then(function (n) {
      if (!s._listeners) return;
      var r = s._listeners.length;
      for (; r-- > 0;) s._listeners[r](n);
      s._listeners = null;
    }), this.promise.then = function (n) {
      var r;
      var o = new Promise(function (i) {
        s.subscribe(i), r = i;
      }).then(n);
      return o.cancel = function () {
        s.unsubscribe(r);
      }, o;
    }, e(function (r, o, i) {
      s.reason || (s.reason = new u(r, o, i), t(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  return _createClass(c, [{
    key: "throwIfRequested",
    value: function throwIfRequested() {
      if (this.reason) throw this.reason;
    }
    /**
     * Subscribe to the cancel signal
     */
  }, {
    key: "subscribe",
    value: function subscribe(e) {
      if (this.reason) {
        e(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(e) : this._listeners = [e];
    }
    /**
     * Unsubscribe from the cancel signal
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe(e) {
      if (!this._listeners) return;
      var t = this._listeners.indexOf(e);
      t !== -1 && this._listeners.splice(t, 1);
    }
  }, {
    key: "toAbortSignal",
    value: function toAbortSignal() {
      var _this = this;
      var e = new AbortController(),
        t = function t(s) {
          e.abort(s);
        };
      return this.subscribe(t), e.signal.unsubscribe = function () {
        return _this.unsubscribe(t);
      }, e.signal;
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
  }], [{
    key: "source",
    value: function source() {
      var e;
      return {
        token: new c(function (n) {
          e = n;
        }),
        cancel: e
      };
    }
  }]);
}();
export { c as default };
